/*
 * @Description: 下拉选择组件
 * @Author: zhongshanxian01
 * @Date: 2021-04-22 09:56:30
 * @LastEditors: zhongshanxian01
 * @LastEditTime: 2021-04-22 15:52:42
 */

import React, { useState, useEffect } from 'react';
import '@styles/components/select.scss';

export interface Options {
    id: any;
    name: any;
}
export interface Props {
    customClass?: string;
    placeHolder?: string;
    value?: Options;
    defaultValue?: any;
    options: Options[];
    onChange?: CallableFunction;
}

const Select = (props: Props) => {
    const [show, setShow] = useState(false);
    const hideOptionsList = () => {
        setShow(false);
    };
    const toggleOptionsList = () => {
        setShow(!show);
    };
    const handleClickOption = (item: Options) => {
        props.onChange && props.onChange(item);
        hideOptionsList();
    };
    const handleClickDefault = (e: React.MouseEvent) => {
        e.stopPropagation();
        toggleOptionsList();
    };
    useEffect(() => {
        window.addEventListener('click', hideOptionsList);
        return () => {
            window.removeEventListener('click', hideOptionsList);
        };
    });

    return (
        <div
            className={`select_box ${show ? 'open' : 'closed'} ${
                props.customClass ? props.customClass : ''
            } ${props.options.length < 2 ? 'hide_box' : ''}`}
            onClick={(e) => {
                handleClickDefault(e);
            }}
        >
            <div className="select_box_selected">
                <div className="cur_selected">
                    <a className="show_item btn current font-custom">
                        {(props.value && props.value.name) || props.placeHolder || '请选择'}
                    </a>
                </div>
                <div className="select_btn"></div>
            </div>
            <div className="select-mask"></div>
            <div className="select_box_list">
                <div className={`inner-content ${props.options.length < 6 ? ' less-list' : ''}`}>
                    {props.options.map((option, index) => {
                        return (
                            <a
                                className={`${
                                    option.id == (props.value && props.value.id) ? 'selected ' : ''
                                }show_item btn`}
                                key={index}
                                onClick={() => {
                                    handleClickOption(option);
                                }}
                            >
                                <span>{option.name}</span>
                            </a>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default Select;
